import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { ConferenceProvider } from '@/context/ConferenceContext';
import './App.css';

import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import SpeakersPage from './pages/SpeakersPage';
import SchedulePage from './pages/SchedulePage';
import WorkshopsPage from './pages/WorkshopsPage';
import CallForPapers from './pages/CallForPapers';
import Submission from './pages/Submission';
import Registration from './pages/Registration';
import DiscountRegistration from './pages/DiscountRegistration';
import VenueTravel from './pages/VenueTravel';
import SponsorsPage from './pages/SponsorsPage';
import CommitteePage from './pages/CommitteePage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import BrochureDownload from './pages/BrochureDownload';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <ConferenceProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/speakers" element={<SpeakersPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/workshops" element={<WorkshopsPage />} />
              <Route path="/call-for-papers" element={<CallForPapers />} />
              <Route path="/submit" element={<Submission />} />
              <Route path="/register" element={<Registration />} />
              <Route path="/discount-registration" element={<DiscountRegistration />} />
              <Route path="/brochure" element={<BrochureDownload />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/venue" element={<VenueTravel />} />
              <Route path="/sponsors" element={<SponsorsPage />} />
              <Route path="/committee" element={<CommitteePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <Toaster position="top-right" />
          </div>
        </BrowserRouter>
      </ConferenceProvider>
    </HelmetProvider>
  );
}

export default App;
